import { render, staticRenderFns } from "./CardbagLingqu.vue?vue&type=template&id=167563a5&scoped=true&"
import script from "./CardbagLingqu.vue?vue&type=script&lang=js&"
export * from "./CardbagLingqu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167563a5",
  null
  
)

export default component.exports